import { render, staticRenderFns } from "./ChatFilter.vue?vue&type=template&id=01c814d2&scoped=true&"
import script from "./ChatFilter.vue?vue&type=script&lang=js&"
export * from "./ChatFilter.vue?vue&type=script&lang=js&"
import style0 from "./ChatFilter.vue?vue&type=style&index=0&id=01c814d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c814d2",
  null
  
)

export default component.exports